module.exports = __webpack_public_path__ + "77928df25e0ea5a7f0aba50ce67595e8.png";